module.exports = __webpack_public_path__ + "images/logo_courtier_et_pret.cd70eeb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/png/logo_courtier_et_pret.png
// module id = 16
// module chunks = 0 1